<div class="status-pills" [ngClass]="{ active: displayMode === Tabbed }" (click)="setDisplayMode.emit(Tabbed)">Tabbed</div>
<div class="status-pills" [ngClass]="{ active: displayMode === Linear }" (click)="setDisplayMode.emit(Linear)">Linear</div>
